<template>
  <div class="roler-container">
    <div class="filter-container">
      <el-input
        v-perm="['/sys/role/view']"
        placeholder="角色名过滤"
        prefix-icon="el-icon-search"
        size="small"
        v-model="filters[0].value"
        style="width: 200px;margin-right: 10px"
        class="filter-item"
      />
      <el-select v-perm="['/sys/role/view']" clearable class="filter-item" size="small" placeholder="状态过滤" v-model="filters[1].value">
        <el-option label="启用" value="true" />
        <el-option label="禁用" value="false" />
      </el-select>
      <el-button v-perm="['/sys/role/add']" class="filter-item" style="margin-left: 10px;" size="mini" type="primary" icon="el-icon-plus" @click="handleRoleAdd">添加</el-button>
    </div>
    <!-- 这一次换成data-table,即过滤排序等都发生在前端 -->
    <data-tables
      :data="data"
      :filters="filters"
      :loading="listLoading"
      :table-props="tableProps"
      :pagination-props="{ background: true, pageSizes: [5, 10, 15, 20] }"
      layout="table,pagination"
      @current-change="handleRoleSelectChange"
    >
      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label" sortable="custom" />

      <el-table-column label="状态" min-width="100px">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | stateFilter(scope.row.status)" size="small">{{ scope.row.status | stateShowFilter(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-button v-perm="['/sys/role/edit']" :size="btnsize" type="success" @click="handleRoleUpdate(scope.row)">编辑</el-button>
          <el-button v-perm="['/sys/role/del']" :size="btnsize" type="danger" @click="handleRoleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </data-tables>

    <el-dialog :title="textMap[operateType]" :visible.sync="dialogFormVisible" width="36%">
      <el-form ref="dataForm" :rules="rules" :model="formData" :inline="inline" status-icon style="width: 500px; margin-left: 50px" label-width="80px" label-position="">
        <el-form-item label="角色名称" prop="role_name">
          <el-input v-model.trim="formData.role_name" placeholder="请输入角色名" />
        </el-form-item>
        <el-form-item label="角色说明" prop="remark">
          <el-input v-model.trim="formData.remark" placeholder="请输入角色备注" />
        </el-form-item>
        <el-form-item label="排序ID">
          <!-- onkeypress 防止录入e 及其他字符 -->
          <el-input-number v-model.trim="formData.listorder" :min="0" controls-position="right" onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="formData.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="operateType === 'add' ? createRoleInfo() : updateRoleInfo()">确定</el-button>
      </div>
    </el-dialog>
    <div class="tree-menu-container">
      <div class="tree-menu-header">
        角色授权:
        <span>{{ selectRoleName }}</span>
      </div>
      <el-tabs v-model="activeName" tab-position="top" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="菜单类" name="menu">
          <span slot="label"><i class="el-icon-date"></i> 菜单类</span>
          <el-tree
            ref="menuTree"
            v-loading="menuLoading"
            :data="menuData"
            :props="defaultProps"
            :render-content="renderContent"
            :check-strictly="true"
            show-checkbox
            node-key="mid"
            size="mini"
            style="width: 60%;"
            element-loading-text="拼命加载中..."
            @check-change="handleMenuCheckChange"
          />
        </el-tab-pane>
        <el-tab-pane label="角色类[目前简单处理,意义不大]" name="role" disabled>
          <data-tables
            ref="roleTable"
            :data="data"
            :filters="filters"
            :loading="listLoading"
            :table-props="tableProps"
            :pagination-props="{ background: true, pageSizes: [5, 10, 15, 20] }"
            layout="table,pagination"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label" sortable="custom" />

            <el-table-column label="状态" min-width="100px">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status | stateFilter(scope.row.status)" size="small">{{ scope.row.status | stateShowFilter(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
          </data-tables>
        </el-tab-pane>

        <el-tab-pane label="文件类" name="file"><svg-icon icon-class="documentation" /> todo:文件类授权</el-tab-pane>

        <div class="select-all-menu">
          <el-checkbox v-if="activeName === 'menu'" :disabled="selectRole.rid == null" v-model="checkAll" @change="handleCheckAll">
            <b>全选</b>
          </el-checkbox>
        </div>
        <div class="operate-action-btn">
          <el-button :disabled="selectRole.rid == null" size="mini" type="primary" @click="resetSelection">重置</el-button>
          <el-button :loading="authLoading" :disabled="selectRole.rid == null" size="mini" type="primary" @click="submitAuthForm">提交</el-button>
        </div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { DataTables } from "vue-data-tables"
Vue.use(DataTables)

//import perm权限
import perm from "@/directive/permission/index.js" // 权限判断指令

//import { getRoleList, createRole, updateRole, deleteRole } from "@/api/role"
import { getRoleList, createRole, updateRole, deleteRole, getAllMenus, getRoleMenu, getRoleRole, saveRoleMenuPerms } from "@/api/role"
export default {
  directives: { perm },
  name: "Role",
  filters: {
    stateFilter(status) {
      const stateMap = {
        true: "success",
        false: "danger"
      }
      return stateMap[status]
    },
    stateShowFilter(status) {
      const stateShowMap = {
        true: "启用",
        false: "禁用"
      }
      return stateShowMap[status]
    }
  },
  data() {
    return {
      data: [],
      //data-table一次把数据请求到前台
      //total: 0,
      listLoading: true,
      tableProps: {
        border: false,
        stripe: true,
        highlightCurrentRow: true,
        defaultSort: {
          prop: "listorder",
          order: "ascending"
        }
      },
      filters: [
        {
          prop: "role_name",
          value: ""
        },
        {
          //状态:启用/禁用
          prop: "status",
          value: ""
        }
      ],
      formData: {
        role_name: "",
        remark: "",
        status: true,
        listorder: 99
      },
      rules: {
        role_name: [{ required: true, message: "请输入用户名", trigger: "blur" }]
      },
      dialogFormVisible: false,
      operateType: "",
      titles: [
        {
          prop: "rid",
          label: "ID"
        },
        {
          prop: "role_name",
          label: "角色名称"
        },
        {
          prop: "remark",
          label: "说明"
        },
        {
          prop: "listorder",
          label: "排序"
        }
      ],
      btnsize: "mini",
      textMap: {
        update: "编辑角色",
        add: "新增角色"
      },
      inline: false,
      activeName: "menu",
      menuLoading: false,
      menuData: [],
      defaultProps: {
        children: "children",
        label: "title"
      },
      checkAll: false,
      selectRole: {},
      selectRoleName: "",
      currentRoleMenus: [],
      currentRoleRoles: [],
      authLoading: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.listLoading = true
      getRoleList().then(res => {
        this.data = res.data.items
        //this.total = res.data.total
        this.listLoading = false
      })
      //获取所有menus
      getAllMenus().then(res => {
        this.menuData = res.data
        this.menuLoading = false
      })
      //如果考虑角色类的话，重新获取一下roles，数据库返回一个permission_id
      //getRoleWithPermId()
    },
    resetformData() {
      this.formData = {
        role_name: "",
        remark: "",
        status: true,
        listorder: 99
      }
    },
    handleRoleAdd() {
      this.resetformData()
      this.dialogFormVisible = true
      this.operateType = "add"
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate()
      })
    },
    createRoleInfo() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          createRole(this.formData).then(res => {
            this.fetchData()
            this.dialogFormVisible = false
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        }
      })
    },
    updateRoleInfo() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          updateRole(this.formData).then(res => {
            this.fetchData()
            this.dialogFormVisible = false
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        }
      })
    },
    handleRoleUpdate(rowdata) {
      //console.log(rowdata)
      this.formData = Object.assign({}, rowdata)
      this.dialogFormVisible = true
      this.operateType = "update"
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate()
      })
    },
    handleRoleDelete(rowdata) {
      this.$confirm("此操作将永久删除角色 : [" + rowdata.role_name + "] ， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const formData = {
          rid: rowdata.rid,
          role_name: rowdata.role_name
        }
        deleteRole(formData).then(res => {
          this.fetchData()
          this.$notify({
            message: res.message,
            type: res.type
          })
        })
      })
    },
    handleRoleSelectChange(val) {
      if (val === null || val.rid === null) {
        return
      }
      this.selectRole = val
      this.selectRoleName = val.role_name
      const roleData = { roleId: this.selectRole.rid }
      getRoleMenu(roleData)
        .then(res => {
          //console.log(res.data)
          this.currentRoleMenus = res.data
          this.$refs.menuTree.setCheckedNodes(res.data)
        })
        .catch(() => {})
      getRoleRole(roleData).then(res => {
        this.currentRoleRoles = res.data
        this.$refs.roleTable.$refs.elTable.clearSelection()
        if (this.currentRoleRoles.length) {
          for (let i = 0; i < this.currentRoleRoles.length + 1; i++) {
            this.$refs.roleTable.$refs.elTable.toggleRowSelection(this.data[i], true)
          }
        }
      })
    },
    handleTabClick() {},
    //子选中，父必选中 ，父删除，子也要删除
    handleMenuCheckChange(data, checked) {
      if (checked) {
        const parentId = data.parent_id
        if (parentId && parentId !== 0) {
          this.$refs.menuTree.setChecked(parentId, true, false)
        }
      } else {
        const childrenIds = data.children
        if (childrenIds.length) {
          childrenIds.forEach(ele => {
            this.$refs.menuTree.setChecked(ele.mid, false, false)
          })
        }
      }
    },
    handleCheckAll() {
      if (this.checkAll) {
        //node-key="mid" 根据这个选中
        const dest = []
        this.transAllMenu(this.menuData, dest)
        this.$refs.menuTree.setCheckedNodes(dest)
      } else {
        this.$refs.menuTree.setCheckedNodes([])
      }
    },
    //递归展开
    transAllMenu(source, dest) {
      source.forEach(ele => {
        dest.push(ele)
        if (ele.children) {
          this.transAllMenu(ele.children, dest)
        }
      })
    },
    submitAuthForm() {
      const roleId = this.selectRole.rid
      if (roleId === 2) {
        this.$message({ message: "超级管理员角色拥有所有权限，不允许修改！", type: "error" })
        return
      }
      this.authLoading = true

      if (this.activeName === "menu") {
        const roleMenuPerms = []
        //获取选中的菜单类权限
        const checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)
        //获取当前的menu选项
        checkedNodes.forEach(ele => {
          const roleMenuPerm = { role_id: roleId, permission_id: ele.perm_id }
          roleMenuPerms.push(roleMenuPerm)
        })
        //console.log(roleId, roleMenuPerms)
        //获取当前的role选项

        saveRoleMenuPerms(roleId, roleMenuPerms).then(res => {
          //console.log(res)
          this.$notify({
            message: res.message,
            type: res.type
          })
          this.authLoading = false
        })
      } else if (this.activeName === "role") {
        this.authLoading = false
        console.log("to do role, 貌似没啥意义")
      } else {
        this.authLoading = false
        console.log("todo: file permission management")
      }
    },
    resetSelection() {
      this.checkAll = false
      //重置菜单类
      this.$refs.menuTree.setCheckedNodes(this.currentRoleMenus)
      //重置角色类
      //1 先清空
      this.$refs.roleTable.$refs.elTable.clearSelection()
      if (this.currentRoleRoles.length) {
        for (let i = 0; i < this.currentRoleRoles.length + 1; i++) {
          this.$refs.roleTable.$refs.elTable.toggleRowSelection(this.data[i], true)
        }
      }
    },
    renderContent(h, { data }) {
      return (
        <span class="column-container">
          <span>{data.title}</span>
          <span>
            <el-tag type={data.mtype === 0 ? "" : data.mtype === 1 ? "success" : "info"} size="small">
              {data.mtype === 0 ? "目录" : data.mtype === 2 ? "功能" : "菜单"}
            </el-tag>
          </span>
          <span>
            <i class={data.icon}></i>
          </span>
          <span style="width: 116px">{data.path ? data.path : "\t"}</span>
        </span>
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.roler-container {
  margin-top: 30px;
  .filter-container {
    margin-bottom: 30px;
  }
  .tree-menu-container {
    padding: 30px;
    margin-top: 50px;
    background: #fff;
    .tree-menu-header {
      margin-top: 10px;
      padding-left: 8px;
      padding-bottom: 22px;
      text-align: left;
      font-size: 20px;
      color: rgb(20, 89, 121);
      span {
        color: red;
      }
    }
    .column-container {
      margin-top: 8px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }
    ::v-deep .el-tree-node__content {
      height: 38px;
    }
    .select-all-menu {
      float: left;
      padding-left: 24px;
      padding-top: 12px;
      padding-bottom: 4px;
    }
    .operate-action-btn {
      float: right;
      padding-right: 15px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
}
.pagination-wrap {
  margin-top: 10px;
  text-align: center;
}
</style>
